import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {SubmitToRdComponent} from './submit-to-rd.component';
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule} from 'primeng/primeng';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ProgressBarModule} from 'primeng/progressbar';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    ProgressBarModule,
    CoreModule,
    TableModule,
    TranslateModule
    // TaxReportRoutingModule
  ],
  declarations: [SubmitToRdComponent]
})
export class SubmitToRdModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.module.ts